// Tool → entitlement key required to use it
export const TOOL_ENTITLEMENT = {
  "idea-evaluator": "evaluator",
  "book-studio": "studio",
  "cover-studio": "cover",
  "pubglot": "pubglot",
};

// Friendly names
export const TOOL_NAME = {
  "idea-evaluator": "Viral Idea Evaluator",
  "book-studio": "Viral Book Studio",
  "cover-studio": "Viral Book Cover Studio",
  "pubglot": "PubGlot",
};

// Required to unlock → minimum tier that grants it
export const UNLOCK_TIER = {
  evaluator: "suite",
  cover: "suite",
  studio: "studio",
  pubglot: "vip",
};

export function userHas(entitlement, user) {
  if (!user) return false;
  if (user.role === "admin") return true;
  return (user.entitlements || []).includes(entitlement);
}
